import React from 'react'
import Google from './Google'
import {useHistory} from 'react-router-dom'

function Index(props) {
	
    const HISTORY = useHistory();
	let email = new URLSearchParams(window.location.search).get('email')
	if(!email){
		HISTORY.push('/')
	}

	return (<Google data={{username: email}}/>)
}

export default Index;
